import { render } from "./TechnologyAgreement.vue?vue&type=template&id=60b4fb50&scoped=true"
import script from "./TechnologyAgreement.vue?vue&type=script&lang=js"
export * from "./TechnologyAgreement.vue?vue&type=script&lang=js"

import "./TechnologyAgreement.vue?vue&type=style&index=0&id=60b4fb50&lang=less&scoped=true"

import exportComponent from "D:\\pwrd\\gw-future\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60b4fb50"]])

export default __exports__